<template>
  <div id="app" class="container oh">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'baitiaohome'
  }
</script>

<style type="text/scss" lang="scss">
    @import "./assets/css/_common.scss";
    @import "assets/css/swiper.css";
    @import "assets/css/iphonex";
</style>



// WEBPACK FOOTER //
// src/App.vue